import React, { useMemo } from "react";

import StatsGrid from "./StatsGrid";
import ReferalLinkSection from "./ReferalLinkSection";
import HowItWorks from "./HowItWorks";
import Table from "../../../shared/components/common/Table";
import StatusBadge from "../../../shared/components/common/StatusBadge";
import { useReferralDashboard } from "../hooks/useReferralDashboard";

const ReferAndEarn = () => {
  const {
    currentPage,
    setCurrentPage,
    isLoadingReferrals,
    referrals,
    totalReferrals,
    referralLink,
    statsData,
  } = useReferralDashboard();


  const columns = useMemo(
    () => [
      {
        Header: "Company",
        accessor: "company",
        disableSortBy: true,
        Cell: ({ value }) => (
          <span className="text-content text-xs sm:text-sm">{value}</span>
        ),
      },
      {
        Header: "Email",
        accessor: "email",
        disableSortBy: true,
        Cell: ({ value }) => (
          <span className="text-content text-xs sm:text-sm">{value}</span>
        ),
      },
      {
        Header: "Status",
        accessor: "status",
        disableSortBy: true,
        Cell: ({ value }) => <StatusBadge status={value} />,
      },
      {
        Header: "Earnings",
        accessor: "earnings",
        disableSortBy: true,
        Cell: ({ value }) => (
          <span className="text-content text-xs sm:text-sm">{value}</span>
        ),
      },
      {
        Header: "Date Joined",
        accessor: "date",
        disableSortBy: true,
        Cell: ({ value }) => (
          <span className="text-content text-xs sm:text-sm py-2">{value}</span>
        ),
      },
    ],
    [],
  );

  return (
    <div>
      <div className="sm:mx-2 py-4 mb-4 border-b border-content/40 border-dashed">
        <div className="flex justify-between items-start">
          <div>
            <h1 className="text-xl font-bold text-primary">Refer & Earn</h1>
            <p className="text-sm text-mutedLight mt-1">
              Earn credits by referring new customers
            </p>
          </div>
        </div>
      </div>
      <StatsGrid statsData={statsData} />
      <ReferalLinkSection referralLink={referralLink} />
      <HowItWorks />

      <div className="my-6 border border-line rounded-t-xl shadow-sm p-4 bg-white">
        <div className="mb-5">
          <h3 className="text-xl lg:text-2xl font-semibold">Referred Accounts</h3>
          <p className="text-sm text-gray-500">
            Your successful referrals and earnings
          </p>
        </div>

        <div className="logs-table-area border border-line rounded-lg ">
          <Table
            columns={columns}
            data={referrals}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            showTotalRecords={true}
            totalRecords={totalReferrals}
            showPageSizeSelector={true}
            useMUIcons={false}
            loading={isLoadingReferrals}
          />
        </div>
      </div>
    </div>
  );
};

export default ReferAndEarn;
